import { graphql } from '@/generated/gql';

export const DEMAND_SEQUENCE_NUMBER_QUERY = graphql(`
  query DemandSequenceNumber($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        sequenceNumber
      }
    }
  }
`);
